export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add"])},
        "empty-list-error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The list must contain at least 1 element"])},
        "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
      },
      "fr": {
        "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter"])},
        "empty-list-error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La liste doit contenir au moins 1 élément"])},
        "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer"])}
      }
    }
  })
}
